import './styles/main.css';
import { initApp } from './components/app';

// Initialize the application
document.addEventListener('DOMContentLoaded', () => {
  initApp();
});
